/**
 * public/landing/images/tez-hop-logo.png — при смене файла увеличь LOGO_CACHE_BUST и
 * такой же ?v=… в public/index.html, public/manifest*.json, public/demo.html
 * (сброс кэша favicon / PWA / иконка на экране «Домой»).
 */
export const LOGO_CACHE_BUST = '5';

const base = process.env.PUBLIC_URL || '';
export const logoPng = () => `${base}/landing/images/tez-hop-logo.png?v=${LOGO_CACHE_BUST}`;
